import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, Injectable, NgModule } from "@angular/core";
import { IonicApp, IonicModule } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";

import { MyApp } from "./app.component";
import { ItemDetailPageModule } from "../pages/item-detail/item-detail.module";
import { Api } from "../services/api";
import { HttpModule } from "@angular/http";
import { Util } from "../services/util";
import { User } from "../services/user";
import { CampaignDetailPageModule } from "../pages/campaign-detail/campaign-detail.module";
import { IonicStorageModule } from "@ionic/storage";
import { MyCampaignsPageModule } from "../pages/my-campaigns/my-campaigns.module";
import { OrderDetailPageModule } from "../pages/order-detail/order-detail.module";
import { Purchase } from "../services/purchase";
import { AlipayPortalPageModule } from "../pages/alipay-portal/alipay-portal.module";
import { SubscribeNotificationSuccessfulPageModule } from "../pages/subscribe-notification-successful/subscribe-notification-successful.module";
import { BindAccountPageModule } from "../pages/bind-account/bind-account.module";
import { FlagsPageModule } from "../pages/flags/flags.module";
import { CreateWeixinLoginPageModule } from "../pages/create-weixin-login/create-weixin-login.module";
import { LoginByWeixinPageModule } from "../pages/login-by-weixin/login-by-weixin.module";
import { CampaignCashRewardPageModule } from "../pages/campaign-cash-reward/campaign-cash-reward.module";
import { Poster } from "../services/poster";
import { LoginPageModule } from "../pages/login/login.module";
import { WeixinPayOrderPageModule } from "../pages/weixin-pay-order/weixin-pay-order.module";
import { MwebPayPageModule } from "../pages/mweb-pay/mweb-pay.module";
import { DiagnosisPageModule } from "../pages/diagnosis/diagnosis.module";
import { WeixinQr } from "../services/weixin_qr";
import { ShareCard } from "../services/sharecard";
import { ResellerPaymentLinkPageModule } from "../pages/reseller-payment-link/reseller-payment-link.module";
import { ResellerOrderListPageModule } from "../pages/reseller-order-list/reseller-order-list.module";
import { ResellerOrderDetailPageModule } from "../pages/reseller-order-detail/reseller-order-detail.module";

// import VConsole from "vconsole";
// let vConsole = new VConsole();

if (
  !window.location.hash ||
  window.location.hash === "#" ||
  window.location.hash === "#/"
) {
  window.location.hash = "/my-campaigns";
}

Sentry.init({
  dsn: "https://1ed9cfe0267e434d8fedff4f554a661c@sentry.notelix.com/2",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {}

  handleError(error) {
    console.error(error);
    if (error.toString().indexOf("[trivial-error]") < 0) {
      Sentry.captureException(error.originalError || error);
    }
  }
}

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      mode: "ios",
      backButtonText: "后退",
      iconMode: "ios",
      modalEnter: "modal-slide-in",
      modalLeave: "modal-slide-out",
      tabbarPlacement: "bottom",
      pageTransition: "ios",
    }),
    LoginPageModule,
    ItemDetailPageModule,
    CampaignDetailPageModule,
    WeixinPayOrderPageModule,
    CampaignCashRewardPageModule,
    FlagsPageModule,
    MyCampaignsPageModule,
    OrderDetailPageModule,
    AlipayPortalPageModule,
    SubscribeNotificationSuccessfulPageModule,
    BindAccountPageModule,
    CreateWeixinLoginPageModule,
    LoginByWeixinPageModule,
    MwebPayPageModule,
    DiagnosisPageModule,
    ResellerPaymentLinkPageModule,
    ResellerOrderListPageModule,
    ResellerOrderDetailPageModule,
    HttpModule,
    IonicStorageModule.forRoot({
      name: "kanjia-app",
      driverOrder: ["localstorage"],
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],

  providers: [
    StatusBar,
    SplashScreen,
    User,
    Api,
    Util,
    Purchase,
    Poster,
    WeixinQr,
    ShareCard,
    { provide: ErrorHandler, useClass: SentryErrorHandler },
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts